import { useContext } from "react";
import { I18nContext } from "../../i18n/useI18n";
import PrincipalBanner from "../../contents/PrincipalBanner";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import Collapse from "../../components/Collapse";

const measurementContent = "pages.experiments.measurements-and-results";

const Page = () => {
  const { t } = useContext(I18nContext);
  return (
    <main className="mx-auto my-0 max-w-7xl">
      <PrincipalBanner
        bgColor="grape"
        classNames={twMerge(clsx("min-h-[200px] md:min-h-[400px] p-0"))}
      >
        <img
          className="absolute w-full min-h-full object-cover"
          src="https://static.igem.wiki/teams/5058/banner-measurement-v2.svg"
          alt="bannner engineering"
        />
        <h1 className="invisible">{t(`${measurementContent}.title`)}</h1>
      </PrincipalBanner>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.introduction.title`)}</h1>
        <p className="py-20">{t(`${measurementContent}.introduction.text`)}</p>
        <p>{t(`${measurementContent}.introduction.text2`)}</p>
        <p className="py-20">{t(`${measurementContent}.introduction.text3`)}</p>
        <p>{t(`${measurementContent}.introduction.text4`)}</p>
      </section>

      <section className="px-6 py-8">
        <h1 className="py-10">{t(`${measurementContent}.how.title`)}</h1>
        <h2>{t(`${measurementContent}.how.title2`)}</h2>
        <p>{t(`${measurementContent}.how.text`)}</p>

        <p>
          <img
            className="inline-block mx-auto w-full"
            src="https://static.igem.wiki/teams/5058/meas-fig01.svg"
            alt=""
          />

          {t(`${measurementContent}.how.legend`)}
        </p>
        <p className="py-20">{t(`${measurementContent}.how.text2`)}</p>

        <p className="py-3">
          <img
            className="inline-block float-left mx-auto max-w-80"
            src="https://static.igem.wiki/teams/5058/meas-eq1.svg"
            alt=""
          />
          <ul>
            <li>{t(`${measurementContent}.how.formula_legend.micro`)}</li>
            <li>{t(`${measurementContent}.how.formula_legend.time`)}</li>
            <li>{t(`${measurementContent}.how.formula_legend.celldensity`)}</li>
            <li>
              {t(`${measurementContent}.how.formula_legend.timeinterval`)}
            </li>
          </ul>
        </p>
        <p className="py-20">{t(`${measurementContent}.how.text3`)}</p>
        <p>
          <img
            className="inline-block mx-auto w-full"
            src="https://static.igem.wiki/teams/5058/meas-fig2.svg"
            alt=""
          />
        </p>
        <p className="py-20">{t(`${measurementContent}.how.legend2`)}</p>
        <p className="py-20">{t(`${measurementContent}.how.text4`)}</p>
        <p>
          <img
            className="block mx-auto max-w-80"
            src="https://static.igem.wiki/teams/5058/meas-eq2.svg"
            alt=""
          />
        </p>
        <p>
          <img
            className="inline-block mx-auto w-full"
            src="https://static.igem.wiki/teams/5058/meas-table1.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.how.legend3`)}</p>
        <p>
          <img
            className="inline-block mx-auto w-full"
            src="https://static.igem.wiki/teams/5058/meas-fig3.svg"
            alt=""
          />
          <p>{t(`${measurementContent}.how.legend4`)}</p>
          <p className="py-20">{t(`${measurementContent}.how.text5`)}</p>
        </p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.what.title`)}</h1>
        <p>{t(`${measurementContent}.what.text`)}</p>
        <p>
          <img
            className="inline-block mx-auto w-full"
            src="https://static.igem.wiki/teams/5058/meas-fig4.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.what.legend`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.how2.title`)}</h1>
        <p>{t(`${measurementContent}.how2.text`)}</p>
        <p>{t(`${measurementContent}.how2.text2`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-70"
            src="https://static.igem.wiki/teams/5058/meas-eq3.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.how2.text3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-fig5.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.how2.legend`)}</p>
        <p py-10>{t(`${measurementContent}.how2.text4`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-eq4.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.how2.legend2`)}</p>
        <p>{t(`${measurementContent}.how2.text6`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-fig6.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.how2.legend3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-table2.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.how2.legend4`)}</p>
        <p>{t(`${measurementContent}.how2.text7`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.medicao-NR.title`)}</h1>
        <h2>{t(`${measurementContent}.medicao-NR.title2`)}</h2>
        <p>{t(`${measurementContent}.medicao-NR.text`)}</p>

        <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
          {t(`${measurementContent}.medicao-NR.title3`)}
        </h3>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-fig7.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.medicao-NR.legend`)}</p>
        <p>{t(`${measurementContent}.medicao-NR.text2`)}</p>
        <p>{t(`${measurementContent}.medicao-NR.text3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-fig8.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.medicao-NR.legend2`)}</p>
        <p>{t(`${measurementContent}.medicao-NR.text4`)}</p>
        <ul>
          <li>
            {t(`${measurementContent}.medicao-NR.formula_legend.Representacao`)}
          </li>
          <li>
            {t(`${measurementContent}.medicao-NR.formula_legend.formula`)}
          </li>
          <li>
            {t(`${measurementContent}.medicao-NR.formula_legend.exemplo`)}
          </li>
          <li>
            {t(`${measurementContent}.medicao-NR.formula_legend.diametro`)}
          </li>
          <li>{t(`${measurementContent}.medicao-NR.formula_legend.radius`)}</li>
          <li>
            {t(`${measurementContent}.medicao-NR.formula_legend.calculo`)}
          </li>
        </ul>
        <p>
          <img
            className="inline-block mx-auto max-w-30"
            src="https://static.igem.wiki/teams/5058/meas-fig9.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.medicao-NR.legend3`)}</p>
        <p>{t(`${measurementContent}.medicao-NR.text5`)}</p>
        <p>{t(`${measurementContent}.medicao-NR.text6`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.mission.title`)}</h1>
        <p>{t(`${measurementContent}.mission.text`)}</p>
        <p>{t(`${measurementContent}.mission.text2`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig10.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.mission.legend`)}</p>
        <p>{t(`${measurementContent}.mission.text3`)}</p>
        <p>{t(`${measurementContent}.mission.text4`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig11.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.mission.legend2`)}</p>
        <p>{t(`${measurementContent}.mission.text5`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig12.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.mission.legend3`)}</p>

        <p>{t(`${measurementContent}.mission.text6`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.vision.title`)}</h1>
        <h2>{t(`${measurementContent}.vision.title2`)}</h2>
        <p>{t(`${measurementContent}.vision.text`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig13.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.vision.legend`)}</p>
        <p>{t(`${measurementContent}.vision.text2`)}</p>
        <p>{t(`${measurementContent}.vision.text3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig14.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.vision.legend2`)}</p>
        <p>{t(`${measurementContent}.vision.text4`)}</p>
        <p>{t(`${measurementContent}.vision.text5`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig15.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.vision.legend3`)}</p>
        <p>{t(`${measurementContent}.vision.text6`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig016.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.vision.legend4`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.values.title`)}</h1>
        <p>{t(`${measurementContent}.values.text`)}</p>
        <p>{t(`${measurementContent}.values.text2`)}</p>
        <p>{t(`${measurementContent}.values.text3`)}</p>
        <p>{t(`${measurementContent}.values.text4`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig17.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.values.legend`)}</p>
        <h2>{t(`${measurementContent}.values.title2`)}</h2>
        <p>{t(`${measurementContent}.values.text5`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig18.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.values.legend2`)}</p>
        <p>{t(`${measurementContent}.values.text6`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig19.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.values.legend3`)}</p>
        <p>{t(`${measurementContent}.values.text7`)}</p>
        <p>{t(`${measurementContent}.values.text8`)}</p>
        <p>{t(`${measurementContent}.values.text9`)}</p>
        <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
          {t(`${measurementContent}.values.title3`)}
        </h3>
        <p>{t(`${measurementContent}.values.text10`)}</p>
        <p>{t(`${measurementContent}.values.text11`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig20.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.values.legend4`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig21.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.values.legend5`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.newsession.title`)}</h1>
        <h2>{t(`${measurementContent}.newsession.title2`)}</h2>
        <p>{t(`${measurementContent}.newsession.text`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig22.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newsession.legend`)}</p>
        <p>{t(`${measurementContent}.newsession.text2`)}</p>
        <p>{t(`${measurementContent}.newsession.subtitle`)}</p>
        <p>{t(`${measurementContent}.newsession.numeros`)}</p>
        <p>{t(`${measurementContent}.newsession.numeros2`)}</p>
        <p>{t(`${measurementContent}.newsession.subtitle2`)}</p>
        <p>{t(`${measurementContent}.newsession.numeros3`)}</p>
        <p>{t(`${measurementContent}.newsession.numeros4`)}</p>
        <p>{t(`${measurementContent}.newsession.text3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig23.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newsession.legend2`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-table3.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newsession.legend3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig24.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newsession.legend4`)}</p>
        <p>{t(`${measurementContent}.newsession.text4`)}</p>
        <p>{t(`${measurementContent}.newsession.text5`)}</p>
      </section>
      <section className="px-6 py-8">
        <h1>{t(`${measurementContent}.newssesion2.title`)}</h1>
        <h2>{t(`${measurementContent}.newssesion2.title2`)}</h2>
        <p>{t(`${measurementContent}.newssesion2.text`)}</p>
        <h3 className="mt-5 mb-1 py-3 w-fit font-manjari text-5xl">
          {t(`${measurementContent}.newssesion2.title3`)}
        </h3>
        <p>{t(`${measurementContent}.newssesion2.text2`)}</p>
        <p>{t(`${measurementContent}.newssesion2.text3`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig25.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newssesion2.legend`)}</p>
        <h4>{t(`${measurementContent}.newssesion2.title4`)}</h4>
        <p>{t(`${measurementContent}.newssesion2.text5`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig26.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newssesion2.legend2`)}</p>
        <p>{t(`${measurementContent}.newssesion2.text6`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig27.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newssesion2.legend3`)}</p>
        <p>{t(`${measurementContent}.newssesion2.text7`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig28.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newssesion2.legend4`)}</p>
        <h4>{t(`${measurementContent}.newssesion2.title5`)}</h4>
        <p>{t(`${measurementContent}.newssesion2.text8`)}</p>
        <p>{t(`${measurementContent}.newssesion2.text9`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig29.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newssesion2.legend5`)}</p>
        <p>{t(`${measurementContent}.newssesion2.text10`)}</p>
        <p>
          <img
            className="inline-block mx-auto max-w-29"
            src="https://static.igem.wiki/teams/5058/meas-fig30.svg"
            alt=""
          />
        </p>
        <p>{t(`${measurementContent}.newssesion2.legend6`)}</p>
        <p>{t(`${measurementContent}.newssesion2.text11`)}</p>
      </section>
      <section>
        <Collapse>
          <Collapse.Title>
            <h1>{t(`${measurementContent}.references.title`)}</h1>
          </Collapse.Title>
          <Collapse.Content>
            <p>{t(`${measurementContent}.references.text`)}</p>
            <p>{t(`${measurementContent}.references.text3`)}</p>
            <p>{t(`${measurementContent}.references.text4`)}</p>
            <p>{t(`${measurementContent}.references.text5`)}</p>
            <p>{t(`${measurementContent}.references.text6`)}</p>
            <p>{t(`${measurementContent}.references.text7`)}</p>
            <p>{t(`${measurementContent}.references.text8`)}</p>
            <p>{t(`${measurementContent}.references.text9`)}</p>
            <p>{t(`${measurementContent}.references.text10`)}</p>
            <p>{t(`${measurementContent}.references.text11`)}</p>
            <p>{t(`${measurementContent}.references.text12`)}</p>
            <p>{t(`${measurementContent}.references.text13`)}</p>
            <p>{t(`${measurementContent}.references.text14`)}</p>
            <p>{t(`${measurementContent}.references.text15`)}</p>
          </Collapse.Content>
        </Collapse>
      </section>
    </main>
  );
};
export default Page;
